import ko from 'knockout';
import _ from 'underscore';
import validator from '@bingads-webui-component-legacy/ko-validation/index';
import decimalNumber from '@bingads-webui-component-legacy/humanize/decimal';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/bidlandscape');

export default class {
  constructor(parentItem, parentView) {
    this.parentView = parentView;
    this.entityType = ko.observable('');
    this.suggestedNewValue = ko.observable(_.result(parentItem, 'SuggestedNewValue', ''));
    this.currentValue = ko.observable(_.result(parentItem, 'CurrentValue', ''));
    this.dataArray = ko.observable([]);

    this.helpId = ko.observable('');
    this.showHelp = ko.pureComputed(() => {
      return !_.isEmpty(this.helpId());
    });

    this.userInput = ko.observable('').extend({
      validate: [
        validator.custom((value) => {
          return !_.isEmpty(value) && decimalNumber.isValid(value, true);
        }, i18n.get('ErrorMessage_InputNumericValue'), false),

        validator.custom((value) => {
          return decimalNumber.fromLocalToFloat(value) > 0;
        }, i18n.get('InputValueGreaterThanZero'), false),
      ],
    });

    this.currentSelectedId = ko.observable(-1);
    this.landscapePointsLength = ko.pureComputed(() => {
      return _.size(this.dataArray());
    });
    this.currentSelectedId.subscribe(() => {
      this.parentView.selectionUpdated();
    });
    this.currentSelectedId.extend({ notify: 'always' });

    this.inputInvalidByUser = ko.observable(false);
    this.inputValid = ko.computed({
      read: () => {
        const notCustomInput = this.currentSelectedId() !== this.landscapePointsLength();
        const customInputAndUserNotInvalidIt = this.userInput.isValid() && !this.inputInvalidByUser();

        return notCustomInput || customInputAndUserNotInvalidIt;
      },
      write: _.noop,
    });

    this.inputValid.subscribe((newValue) => {
      if (!newValue && !this.userInput.isValid() && !_.isEmpty(this.userInput.errors())) {
        this.inputErrorMessage(this.userInput.errors()[0]);
      }
    });

    this.inputErrorMessage = ko.observable('');
    this.radioName = ko.observable(`${_.result(parentItem, 'Id', '')}Radio`);
    this.hasData = ko.pureComputed(() => {
      return !_.isEmpty(this.dataArray());
    });

    this.startDateString = ko.observable('');
    this.endDateString = ko.observable('');
    this.inSimpleMode = ko.observable(false);
    this.isClickGraph = ko.observable(false);

    this.valueToApply = ko.computed({
      read: () => {
        if (this.currentSelectedId() < this.landscapePointsLength() && this.currentSelectedId() >= 0) {
          return this.dataArray()[this.currentSelectedId()].bid;
        }

        if (this.currentSelectedId() === this.landscapePointsLength() && this.userInput.isValid()) {
          return decimalNumber.fromLocalToFloat(this.userInput());
        }
        return null;
      },
      write: _.noop,
    });

    this.updatedSelectedIndex = function (index) {
      this.currentSelectedId(index);
      return true; // so that the action can spread to its radio
    }.bind(this);
  }

  convertDataFromResposne(dataToShow, hasZeroCurrentPoint) {
    let landscapePoints = [],
      selectedIndex = -1,
      showClick = false,
      currentBid = decimalNumber.fromLocalToFloat(this.currentValue()),
      suggestedBid = decimalNumber.fromLocalToFloat(this.suggestedNewValue());

    if (!_.isEmpty(dataToShow) && !_.isEmpty(dataToShow.BidLandscapePoints)) {
      const hasClick = (dataToShow.CurveType & 2) === 2; // eslint-disable-line

      landscapePoints = _.chain(dataToShow.BidLandscapePoints)
        .sortBy((point) => -point.Bid)
        .uniq((point) => point.Bid)
        .map((point, id) => {
          const result = {
            impressions: point.Impressions,
            impressionsStr: decimalNumber.fromFloatToString(point.Impressions, 0),
            mlImpressions: point.MLImpressions,
            mlImpressionsStr: decimalNumber.fromFloatToString(point.MLImpressions, 0),
            bid: point.Bid,
            bidStr: decimalNumber.fromFloatToString(point.Bid, 2),
            comment: '',
            index: id,
            clicks: point.Clicks || 0,
            clicksStr: decimalNumber.fromFloatToString(point.Clicks || 0, 0),
            cost: point.Cost || 0,
            costStr: decimalNumber.fromFloatToString(point.Cost || 0, 2),
          };

          if (!hasZeroCurrentPoint && point.Bid === currentBid) {
            selectedIndex = selectedIndex < 0 ? id : selectedIndex;
            result.comment = `(${i18n.get('Current')})`;
          } else if (this.suggestedNewValue() > 0 && point.Bid === suggestedBid) {
            selectedIndex = id;
            result.comment = i18n.get('Suggested');
          }

          showClick = hasClick && point.Clicks > 0 ? true : showClick;
          return result;
        }).filter((point) => {
          if (point.bid === 0 && hasZeroCurrentPoint) { // for adgroup bid landscape, bid 0 means current
            this.customBidCurrentPoint(point);
            return false;
          } else {
            return true;
          }
        }).value();

      selectedIndex = selectedIndex < 0 && !_.isEmpty(dataToShow.BidLandscapePoints) ? 0 : selectedIndex;
    }
    return {
      dataArray: landscapePoints,
      selectedIndex,
      showClick,
    };
  }

  convertDataForBidLandscape(response) {
    if (!_.isEmpty(response.ChartData)) {
      const data = this.convertDataFromResposne(response.ChartData);

      this.isClickGraph(data.showClick);
      this.dataArray(data.dataArray);
      this.currentSelectedId(data.selectedIndex);
      this.startDateString(response.ChartData.StartDateString);
      this.endDateString(response.ChartData.EndDateString);
    }
  }
}
